<fp-footer
    *ngIf="footerSetting$ | async as GeneralSetting"
    [name]="(footerSetting$ | async).company"
    [internetPortalName]="internetPortalName"
    [organisationName]="organisationName"
    [telephone]="(footerSetting$ | async).telephone"
    [email]="(footerSetting$ | async).email"
></fp-footer>
